import { forEach, isEmpty } from 'lodash';

const createAdminsObject = (admins) => {
  if (isEmpty(admins)) return {};

  const obj = {};

  forEach(admins.admins, (value, key) => {
    obj[key] = {
      hasEmrManagerRole: value.has_emr_manager_role,
      grantEmrManagerRoleToAdmin: {
        loading: false,
        error: ''
      },
      revokeEmrManagerRoleFromAdmin: {
        loading: false,
        error: ''
      }
    }
  })

  return obj;
}

export default createAdminsObject;
